var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNutrio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.126 85.8302C19.2553 89.8501 24.0772 93.1622 29.3955 95.5706C45.917 68.6374 68.6374 45.917 95.5706 29.3955C93.6759 25.2115 91.2219 21.3349 88.304 17.8609C58.4199 33.813 33.1773 57.3194 15.126 85.8302Z",
    fill: "#04471C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 46.2748 99.5927 42.6449 98.82 39.1521C74.7505 54.3247 54.3247 74.7505 39.1521 98.82C42.6449 99.5927 46.2749 100 50 100C77.6142 100 100 77.6142 100 50Z",
    fill: "#04471C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6126 82.0395C29.8367 53.6739 55.0324 30.2136 84.7798 14.0783C75.7807 5.36349 63.5167 0 50 0C22.3858 0 0 22.3858 0 50C0 62.1909 4.36295 73.3629 11.6126 82.0395ZM15 60C17.7614 60 20 57.7614 20 55C20 52.2386 17.7614 50 15 50C12.2386 50 10 52.2386 10 55C10 57.7614 12.2386 60 15 60Z",
    fill: "#04471C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNutrio);
export default __webpack_public_path__ + "static/media/Logo-nutrio.2f4d40618998e471e10b1532c79a1f9f.svg";
export { ForwardRef as ReactComponent };